// Libraries
import React, { memo } from 'react';
import { MapContainer, CircleMarker } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';

// Enums
import { GeolocationQuestionDataType, LocationType } from 'engagementReport/enums/propTypes';

// Components
import { StreetMapLayer } from 'common/components/StreetMapLayer';

const GeolocationMap = ({ data, location }) => {
  return (
    <MapContainer
      className="geolocation-report-map"
      center={[location.lat, location.lng]}
      zoom={location.zoom}
      scrollWheelZoom={false}
    >
      <StreetMapLayer />
      <MarkerClusterGroup>
        {data.map(({ id, lat, lng }) => (
          <CircleMarker
            key={id}
            center={[lat, lng]}
            radius={5}
            color="#000000"
            weight={1}
            fill
            fillColor="#de685d"
            fillOpacity={1}
          />
        ))}
      </MarkerClusterGroup>
    </MapContainer>
  );
};

GeolocationMap.propTypes = {
  data: GeolocationQuestionDataType.isRequired,
  location: LocationType.isRequired,
};

export default memo(GeolocationMap);
